import App from 'app';
import { updateIntl } from 'react-intl-redux';
import { connect } from 'react-redux';
import { shoppingCartSetToken } from './actions/shopping-cart';

const mapStateToProps = (state) => {
  const {
    routing,
    shoppingCartToken,
  } = state;

  return {
    shoppingCartToken,
    routing,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLanguage(...payload) {
      dispatch(updateIntl(...payload));
    },
    shoppingCartSetToken(payload) {
      dispatch(shoppingCartSetToken(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./js/container.js